module.exports = __webpack_public_path__ + "img/ExcellenceInEducation.aa575b54.jpg";